module.exports = __webpack_public_path__ + "media/images/arrow-down-gold-12ea1df68aae17f9802a630c45d3ed9b.svg";